console.log('Init femisafe 3.0');
//variables
const popcoinsBottomBtn = document.querySelector("#popcoinsBottomBtn");

const popcoinBtnSpan = document.querySelector("#popcoinBtnSpan");
const popcoinsModalCloseBtn = document.querySelector("#popcoinsModalCloseBtn");

const popcoinsIframeModal = document.querySelector("#popcoinsIframeModal");
const popCoinsIframe = document.querySelector("#popcoinsIframe");
const defaultIframeURL = document.getElementById("pop-club-iframe-url").value;

const key = customCookie();
const parameters = "?shop=" + Shopify.shop + "&key=" + key;

const rewardsName = "FemiSafe Rewards";
const rewardsCallOut = "Get upto 30% Off using";

const getAvailablePopcoinsURL =
  "https://brand-loyalty.popclub.co.in/api/get-available-coins";
const getBrandURL = "https://brand-loyalty.popclub.co.in/api/get-brand?shop=";
const getCartDiscountURL =
  "https://brand-loyalty.popclub.co.in/api/get-coins-cart-discount";
const removeDiscountCode =
  "https://brand-loyalty.popclub.co.in/api/remove-discount-code";

let popCoinsAvailable = false;
let popCoinsLoginFlag = document.querySelector("#pop-club-login-flag");
let popCoins = 0;

var popIconAPI='https://ecomapp-dev-v2.s3.ap-south-1.amazonaws.com/Coin.png',popIcon='<img src="https://ecomapp-dev-v2.s3.ap-south-1.amazonaws.com/Coin.png" height="23px" width="23px" alt="POPcoins Logo">';
const popArrowSvg = '<svg class="pop-arrow" width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9.88326 12.9173L9.88327 12.9177C9.89143 13.1844 9.98336 13.4133 10.1634 13.5934C10.3447 13.7746 10.5755 13.8629 10.8437 13.8629C11.1118 13.8629 11.3427 13.7746 11.524 13.5934L16.938 8.17931C17.0335 8.08386 17.1049 7.97666 17.1478 7.85745L17.1481 7.85673C17.1881 7.74374 17.2075 7.62414 17.2075 7.49902C17.2075 7.37385 17.1881 7.25189 17.1491 7.13376L17.1488 7.13285C17.1064 7.00688 17.0342 6.89975 16.9335 6.81419L11.524 1.40468C11.3427 1.22341 11.1118 1.13516 10.8437 1.13516C10.5755 1.13516 10.3447 1.22341 10.1634 1.40468C9.98336 1.5847 9.89143 1.81366 9.88327 2.08037L9.88326 2.08073C9.87566 2.35011 9.96043 2.5828 10.1429 2.76525L13.9131 6.53542L2.0044 6.76113C1.73491 6.76147 1.50176 6.85429 1.31509 7.04031L1.31473 7.04068C1.12837 7.22768 1.03555 7.46133 1.03555 7.73144C1.03555 8.00156 1.12838 8.23505 1.31491 8.42157C1.50188 8.60854 1.73558 8.70176 2.00586 8.70178L2.0087 8.70173L13.8993 8.47636L10.1429 12.2328C9.96043 12.4152 9.87566 12.6479 9.88326 12.9173Z" fill="#fff" stroke="#5E3654" stroke-width="0.3"/> </svg>';

//PLP
// let productCard = document.querySelectorAll(".product-item .card");
// let popcoinsListingDiv = document.getElementsByClassName("pop-club-listing");

//PDP

//CART DRAWER
let cartDrawerPopcoinsLabel = document.querySelector(
  "#buy-with-pop-coins-cart-drawer-label"
);

//CART PAGE
let cartPagePopcoinsLabel = document.querySelector(
  "#buy-with-pop-coins-cart-page-label"
);

let externalCheckout = "#checkout3";
let externalCheckoutOnPDP = "#gokwik-buy-now";
const lottieAnimation = "";
const rewardNameLottieAnimationLink = "FemiSafe Rewards";
// const lottieAnimation = "<lottie-player class='popcoins-lottie-animation'src='https://ik.imagekit.io/t2vt6tx4m/media/112490-new-tag.json' background='transparent'  speed='1'  style='width: 70px; height: 40px;' loop autoplay></lottie-player>";
// const rewardNameLottieAnimationLink = `FemiSafe Rewards <lottie-player class='popcoins-lottie-animation'src='https://ik.imagekit.io/t2vt6tx4m/media/112490-new-tag.json' background='transparent'  speed='1'  style='width: 70px; height: 40px;' loop autoplay></lottie-player>`;
saveBrandData();
function saveBrandData() {
  fetch(getBrandURL + Shopify.shop)
    .then((response) => response.json())
    .then((data) => {
      popIconAPI = data.popcoins_icon;
      popIcon = `<img src="${popIconAPI}" height="23px" width="23px" alt="POPcoins Logo">`;
      if (localStorage.getItem("popCoinsIframeUrl") !== null) {
        // myKey is set in localStorage
      } else {
        // myKey is not set in localStorage
        localStorage.setItem("popCoinsIframeUrl", data.iframe_url);
      }
      if (localStorage.getItem("popCoinsIssuance") !== null) {
        // myKey is set in localStorage
      } else {
        // myKey is not set in localStorage
        localStorage.setItem("popCoinsIssuance", data.issuance);
      }
      if (localStorage.getItem("popCoinsRedeem") !== null) {
        // myKey is set in localStorage
      } else {
        // myKey is not set in localStorage
        localStorage.setItem("popCoinsRedeem", data.redeem);
      }
    })
    .catch((error) => {
      console.log("Error in brand api - popcoins ", error);
    });
}

// function setIframeURL() {
//   if (localStorage.getItem("") !== null) {
//     popCoinsIframe.src =
//       localStorage.getItem("popCoinsIframeUrl") + "?key=" + key;
//   } else {
//     popCoinsIframe.src = defaultIframeURL + "?key=" + key;
//   }

//   if (window.location.href.indexOf("/cart") != -1) {
//   } else {
//     popcoinsBottomBtn.style.display = "block";
//   }
// }

function loadIframe(){
 load_iframe(); 
}
function load_iframe(isCart = false) {
  let keyvalue1 = document.cookie.split('; ').find((row) => row.startsWith('_shopify_s='))?.split('=')[1];

  let refUrl = new URLSearchParams(document.location.search);
  refUrl = refUrl.get('ref');

  if (refUrl === null) {
    if (sessionStorage.getItem('lastPopReferred') !== null) {
      refUrl = sessionStorage.getItem('lastPopReferred');
    }
  }
  else {
    sessionStorage.setItem('lastPopReferred', refUrl);
  }

  if (window.location.href.indexOf('/products/') != -1) {
    var redeemPrices = document.getElementById('pop-club-redeem-price').value;
    let key = document.cookie
      .split('; ')
      .find((row) => row.startsWith('_shopify_s='))
      ?.split('=')[1];
    let redeemCoins = redeemPrices;
    popCoinsIframe.src =
      defaultIframeURL + '&key=' + key + '&page=pdp&discount=' + redeemCoins + '&url=' + window.location.href + ((isCart) ? '-cart' : '') + ((refUrl !== null) ? '&ref=' + refUrl : '');
  } else {
    let cartPage = '';
    if (window.location.href.indexOf('/cart') != -1) {
      cartPage = '&page=cart';
    }
    popCoinsIframe.src =
      defaultIframeURL + '&key=' + keyvalue1 + cartPage + '&url=' + window.location.href + ((isCart) ? '-cart' : '') + ((refUrl !== null) ? '&ref=' + refUrl : '');
  }
  console.log("iframe loaded");
  body.removeEventListener("mousemove",loadIframe);
  body.removeEventListener("touchstart",loadIframe);
}

function openPopcoinsModal() {
  customAddClass("body", "popcoinsModalActive");
  popcoinsIframeModal.style.display = "block";
}

function create(el) {
  var d = document;
  var element = d.createElement(el);
  element.classList.add("manual-class");
  return element;
}
const body=document.querySelector("body");
body.addEventListener("mousemove",loadIframe);
body.addEventListener("touchstart",loadIframe);
document.addEventListener("DOMContentLoaded", function () {
  // let loaderDiv = document.createElement("div");
  // loaderDiv.setAttribute("class", "popCoinsLoader");
  // document.body.prepend(loaderDiv);
  updateCartData(key);
  // load_iframe();
  addPopcoinsInMenu();
  showPopCoins();
  if (window.location.href.indexOf("/cart") != -1) {
    cartPage();
  }
  if (window.location.href.indexOf("/product") != -1) {
    // window.addEventListener("change", function () {
    //   showPopCoins();
    // });

  }
});

/* event listeners */
popcoinsBottomBtn.addEventListener("click", function () {
  if (document.querySelector("#popcoinsIframe").src.toString().includes('-cart') == false) {
    // load_iframe(true);
    openPopcoinsModal();
  }
  else {
    load_iframe(false);
    openPopcoinsModal();
  }
});

//floater close btn
popcoinsModalCloseBtn.addEventListener("click", function () {
  showPopCoins();
  popcoinsIframeModal.style.display = "none";
  customRemoveClass("body", "popcoinsModalActive");
});
if (window.location.href.indexOf("/products")) {

  let variantSelect = document.querySelector(".product-form__input select");
  if (variantSelect) {
    console.log("variantSelect", variantSelect);
    variantSelect.addEventListener("change", function () {
      setTimeout(function () {
        showPopCoins();
      }, 1000)
    })
  }
}

function callback(){
    const popPDP=document.querySelector("#pop-club-product-detail");
    const pdpPriceContainer=document.querySelector(".ProductMeta__PriceList");
    let pdpPrice=pdpPriceContainer.querySelector(".ProductMeta__Price")?.innerHTML.replace("Rs","").split(".")[1].trim();
    if(pdpPrice.includes(",")) pdpPrice=pdpPrice.split(",").join();
    popPDP.setAttribute("price",pdpPrice)
    console.log("working",pdpPrice)
    showpopCoinsOnPDP();
}
let observer = new MutationObserver(callback);
const pdpPriceContainer=document.querySelector(".ProductMeta__PriceList");
if(pdpPriceContainer) observer.observe(pdpPriceContainer,{childList: true, subtree: true, characterDataOldValue: true})
function customCookie() {
  let key = document.cookie
    .split("; ")
    .find((row) => row.startsWith("_shopify_s="))
    ?.split("=")[1];

  var name1 = "_shopify_s";
  var customCookies = document.cookie.match(
    new RegExp("(^| )" + name1 + "=([^;]+)")
  );

  if (
    key == "undefined" ||
    key == undefined ||
    key == "" ||
    customCookies == null ||
    customCookies == ""
  ) {
    // location.reload();
  }
  return key;
}

function customAddClass(identifier, className) {
  let element = document.querySelector(identifier);
  element.classList.add(className);
}

function customRemoveClass(identifier, className) {
  let element = document.querySelector(identifier);
  element.classList.remove(className);
}

function loading() {
  let popLabels = document.querySelectorAll(".popcoinsLabel");
  let popCheckboxes = document.querySelectorAll(".popcoins-login-checkbox");
  let popText = 'Calculating <img width="30" height="30" src="https://testpopcoin.looksguru.com/sandtime.gif">';
  popLabels.forEach((l) => {
    l.innerHTML = popText;
  });
  popCheckboxes.forEach((c) => {
    c.style.display = "none";
  });
}

function showPopCoins() {
  loading();
  fetch(getAvailablePopcoinsURL + parameters)
    .then((response) => response.json())
    .then((data) => {
      popCoins = data.coins;
      let drawerCheckbox = document.querySelector('.cart-drawer-lottie #buy-with-pop-coins-cart-drawer-checkbox');
      if (data.success == true) {
        popCoinsLoginFlag.value = "true";
        popCoinsAvailable = true;
        if(drawerCheckbox){
          const checkoutBtn=document.querySelector("#checkout3");
          if(checkoutBtn) checkoutBtn.setAttribute("disabled","true");
          if(checkoutBtn) checkoutBtn.classList.add("disable-btn");
          document.getElementById('buy-with-pop-coins-cart-drawer-checkbox').checked = true;
          cartDiscoutAPI();
        }
        // if(window.location.href.indexOf('/cart') != -1){
        //   document.getElementById('buy-with-pop-coins-cart-page-checkbox').checked = true
        // }
      } else {
        popCoinsLoginFlag.value = "false";
        popCoinsAvailable = false;
        if(drawerCheckbox){
          document.getElementById('buy-with-pop-coins-cart-drawer-checkbox').checked = false;
        }
        // if(window.location.href.indexOf('/cart') != -1){
        //   document.getElementById('buy-with-pop-coins-cart-page-checkbox').checked = false
        // }
      }

      // showPopcoinsListing(data);
      PLPCoins(data);
      bottomStrip(data);
      cartDrawerSubTotalChanges();
      cartDrawer();
      showpopCoinsOnPDP();
      if (window.location.href.indexOf("/products") != -1) {
        variantSelector();
        showpopCoinsOnPDP();

        // QUANTITY SELECTOR ON PDP
        if (window.location.href.indexOf("/product") != -1) {

          plusQtyIcon = document.querySelector(
            ".QuantitySelector button:last-child"
          );
          minusQtyIcon = document.querySelector(
            ".QuantitySelector button:first-child"
          );
          if (plusQtyIcon) {
            plusQtyIcon.addEventListener("click", function (e) {
              setTimeout(function () {
                $('.ProductForm__QuantitySelector .QuantitySelector .QuantitySelector__CurrentQuantity').change();
                bottomStrip(data);
              }, 500)
            });
          }
          if (minusQtyIcon) {
            minusQtyIcon.addEventListener("click", function (e) {
              setTimeout(function () {
                $('.ProductForm__QuantitySelector .QuantitySelector .QuantitySelector__CurrentQuantity').change();
                bottomStrip(data);
              }, 500)
            });
          }
        }
      }
      if (window.location.href.indexOf("/cart") != -1) {
        cartPage();
        cartPageSubTotalChanges(data);
        let changeCheckbox = document.querySelector('#buy-with-pop-coins-cart-page-checkbox');
        changeCheckbox.addEventListener('change', function () {
          console.log('change');
          cartPageSubTotalChanges(data);
        })
      }
      if (drawerCheckbox) {
        drawerCheckbox.addEventListener('change', function () {
          cartDrawerSubTotalChanges();
        });
      }
    });
}
let cartDiscout;
function cartDiscoutAPI(){
  clearTimeout(cartDiscout);
  cartDiscout = setTimeout(()=>{
    customCartCheckout();
  },1000);
}
// Cart third party checkout
const customCartCheckout=async()=>{
  try{
    const resp = await fetch(window.Shopify.routes.root + 'cart.js')
	const data = await resp.json();
    let priceLength = (data['items_subtotal_price'].toString().length) - 2;
    let price = data['items_subtotal_price'].toString().slice(0, priceLength) + "." + data['items_subtotal_price'].toString().slice(priceLength);
    
    let variants = '';
      for (let i = 0; i < data['items'].length; i++) {
        variants += data['items'][i]['variant_id'] + '-' + data['items'][i]['quantity'] + ',';
      }
    let cartParams=`?cart=${price}&shop=${Shopify.shop}&key=${key}&variants=${variants}`;
    if(price>0){
    const cartUrl=`https://brand-loyalty.popclub.co.in/api/get-coins-cart-discount${cartParams}`;
    const pop_resp=await fetch(cartUrl);
    const pop_data=await pop_resp.json();
     let now = new Date();
    let time = now.getTime();
    time += 3600 * 1000;
    now.setTime(time);
    document.cookie = `discount_code=${pop_data.code};expires=${now.toUTCString()};path=/`;
    }
  }catch(err){
    console.log(err)
  }finally{
    const checkoutBtn=document.querySelector("#checkout3");
          if(checkoutBtn) checkoutBtn.removeAttribute("disabled");
          if(checkoutBtn) checkoutBtn.classList.remove("disable-btn");
  }
}
// function showPopcoinsListing(data) {
//   let popcoinsDiv = document.getElementsByClassName("pop-club-listing");
//   for (let i = 0; i < popcoinsDiv.length; i++) {

//     let price = popcoinsDiv[i].getAttribute("price");
//     if (data.success == true && price > 99) {
//       if (data.coins > 0) {
//         console.log('truee--');
//         let redeemCoins = Math.round(
//           (localStorage.getItem("popCoinsRedeem") / 100) * price
//         );
//         if (redeemCoins > data.coins && data.success == true) {
//           redeemCoins = data.coins;
//         }
//         let redeemPrice = Math.round(price - redeemCoins);
//         let popHTML =
//           "<p>or Rs. " +
//           redeemPrice +
//           " + <span class='pop-img'><img src='https://ecomapp-dev-v2.s3.ap-south-1.amazonaws.com/Coin.png'> </span> " +
//           redeemCoins +
//           "</p>";
//         popcoinsDiv[i].innerHTML = popHTML;
//       }
//       else {
//         popcoinsDiv[i].innerHTML = "";
//       }
//     }
//     else {
//       console.log('false');
//       if (price > 99) {
//         let redeemCoins = Math.round(
//           (localStorage.getItem("popCoinsRedeem") / 100) * price
//         );
//         if (redeemCoins > data.coins && data.success == true) {
//           redeemCoins = data.coins;
//         }
//         let redeemPrice = Math.round(price - redeemCoins);
//         let popHTML =
//           "<p>or Rs. " +
//           redeemPrice +
//           " + <span class='pop-img'><img src='https://ecomapp-dev-v2.s3.ap-south-1.amazonaws.com/Coin.png'> </span> " +
//           redeemCoins +
//           "</p>";
//         popcoinsDiv[i].innerHTML = popHTML;
//       }
//       else {
//         popcoinsDiv[i].innerHTML = "";
//       }
//     }
//   }
// }
// PLP Price listing  
const PLPCoins=(data)=>{
  const popClubListing=document.querySelectorAll(".pop-club-listing");
  if(popClubListing.length && data.coins > 0){
    popClubListing.forEach(el=>{
     let price = el.getAttribute("price");
      let redeemCoins = Math.round((localStorage.getItem("popCoinsRedeem") / 100) * price);
      if(redeemCoins > data.coins && data.success == 'true') redeemCoins=data.coins;
       if (redeemCoins > 0) {
              let redeemPrice = Math.round(price - redeemCoins);
              let popHTML = "<p>or Rs. " + redeemPrice + ` + <span class='pop-img'><img src='${popIconAPI}'> </span> ` + redeemCoins + "</p>";
              el.innerHTML = popHTML;
            }else{
           let popHTML="";
            el.innerHTML = popHTML;
          }
    })
  }
}

//This function
function showpopCoinsOnPDP() {
  let popcoinsPdpDiv = document.querySelector(".pop-club-product");

  if (popcoinsPdpDiv) {
    let price = popcoinsPdpDiv.getAttribute("price");
    if (price > 99) {
      var priceValue = Math.floor(price);

      if (priceValue.toString().length > 2) {
        var modulePrice = priceValue % 100;
        var roundedPrice = priceValue - modulePrice;
      } else {
        var roundedPrice = 0;
      }
      let issueCoins = Math.round(
        (localStorage.getItem("popCoinsIssuance") / 100) * roundedPrice
      );
      popHTML =
        `<p id='product-issuance-msg' class='popCoinsEarnCallout'>Earn<span class='pop-img'> <img src='${popIconAPI}'> </span> ` +
        issueCoins +
        " on this product</p>";

      let productIssuanceMsg = document.getElementById("product-issuance-msg");
      if (productIssuanceMsg) {
        popcoinsPdpDiv.innerHTML = popHTML;
      } else {
        popcoinsPdpDiv.insertAdjacentHTML("afterbegin", popHTML);
      }
    }
  }
}

// function popCoinsBottomBar(data) {
//   let popCoins = data.coins;
//   let popcoinsPdpDiv = document.querySelector(".pop-club-product");
//   console.log('not coming?');
//   if (popCoinsAvailable) {
//     console.log('coming?');
//     if (window.location.href.indexOf("/product") != -1) {
//       if (popcoinsPdpDiv) {
//         let price = popcoinsPdpDiv.getAttribute("price");
//         let pdpQty = 0;
//         pdpQty = document.querySelector(
//           ".ProductForm__QuantitySelector .QuantitySelector .QuantitySelector__CurrentQuantity"
//         ); //quantity selector
//         $('.ProductForm__QuantitySelector .QuantitySelector .QuantitySelector__CurrentQuantity').change();
//         console.log('hey g');
//         console.log(pdpQty);
//         if (pdpQty) {

//           console.log("pdpQty", parseInt(pdpQty.value));

//           let totalProductPrice = price * parseInt(pdpQty.value);
//           let redeemCoins = Math.round(
//             (localStorage.getItem("popCoinsRedeem") / 100) * totalProductPrice
//           );

//           document.getElementById("pop-club-redeem-price").value = redeemCoins;

//           if (redeemCoins > popCoins && data.success == true) {
//             redeemCoins = popCoins;
//             document.getElementById("pop-club-redeem-price").value = redeemCoins;
//           }
//           if (popCoins == 0) {
//             let popCoinBarHTML =
//               '<div class="available_popcoins"><img width="30" height="30" src="https://ecomapp-dev-v2.s3.ap-south-1.amazonaws.com/Coin.png" loading="lazy">' +
//               redeemCoins +
//               '</div><span class="zeroPopcoinsCallout">Shop and Earn POPcoins</span> <img class="arrow" width="16" height="13" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png" loading="lazy">';
//             popcoinBtnSpan.innerHTML = popCoinBarHTML;
//           } else {
//             let popCoinBarHTML =
//               '<span class="rewards-title">' +
//               rewardsName +
//               "</span>" +
//               rewardsCallOut +
//               ' <div class="available_popcoins"><img width="30" height="30" src="https://ecomapp-dev-v2.s3.ap-south-1.amazonaws.com/Coin.png" loading="lazy">' +
//               redeemCoins +
//               '</div><img class="arrow" width="16" height="13" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png" loading="lazy">';
//             popcoinBtnSpan.innerHTML = popCoinBarHTML;
//           }
//         }
//       } else {
//         let custom_price = document.querySelector('[data-product-type="price"]');
//         console.log(custom_price);
//         let price_pf = custom_price.innerText;
//         console.log(price_pf);
//         let final_price = price_pf.split(" ")[1];
//         console.log(final_price)
//         let pdpQty = 1;
//         // pdpQty = document.querySelector(
//         //   ".ProductForm__QuantitySelector .QuantitySelector .QuantitySelector__CurrentQuantity"
//         // ); //quantity selector
//         // $('.ProductForm__QuantitySelector .QuantitySelector .QuantitySelector__CurrentQuantity').change();
//         // console.log('hey g');
//         console.log(pdpQty);
//         if (pdpQty) {

//           console.log("pdpQty", parseInt(pdpQty.value));

//           let totalProductPrice = final_price * parseInt(1);
//           let redeemCoins = Math.round(
//             (localStorage.getItem("popCoinsRedeem") / 100) * totalProductPrice
//           );

//           document.getElementById("pop-club-redeem-price").value = redeemCoins;

//           if (redeemCoins > popCoins && data.success == true) {
//             redeemCoins = popCoins;
//             document.getElementById("pop-club-redeem-price").value = redeemCoins;
//           }
//           if (popCoins == 0) {
//             let popCoinBarHTML =
//               '<div class="available_popcoins"><img width="30" height="30" src="https://ecomapp-dev-v2.s3.ap-south-1.amazonaws.com/Coin.png" loading="lazy">' +
//               redeemCoins +
//               '</div><span class="zeroPopcoinsCallout">Shop and Earn POPcoins</span> <img class="arrow" width="16" height="13" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png" loading="lazy">';
//             popcoinBtnSpan.innerHTML = popCoinBarHTML;
//           } else {
//             let popCoinBarHTML =
//               '<span class="rewards-title">' +
//               rewardsName +
//               "</span>" +
//               rewardsCallOut +
//               ' <div class="available_popcoins"><img width="30" height="30" src="https://ecomapp-dev-v2.s3.ap-south-1.amazonaws.com/Coin.png" loading="lazy">' +
//               redeemCoins +
//               '</div><img class="arrow" width="16" height="13" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png" loading="lazy">';
//             popcoinBtnSpan.innerHTML = popCoinBarHTML;
//           }
//         }
//       }
//     } else {
//       if (popCoins == 0) {
//         let popCoinBarHTML =
//           '<div class="available_popcoins"><img width="30" height="30" src="https://ecomapp-dev-v2.s3.ap-south-1.amazonaws.com/Coin.png" loading="lazy">' +
//           popCoins +
//           '</div><span class="zeroPopcoinsCallout">Shop and Earn POPcoins</span><img class="arrow" width="16" height="13" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png" loading="lazy">';
//         popcoinBtnSpan.innerHTML = popCoinBarHTML;
//       } else {
//         let popCoinBarHTML =
//           '<span class="rewards-title">' +
//           rewardsName +
//           "</span>" +
//           rewardsCallOut +
//           '<div class="available_popcoins"><img width="30" height="30" src="https://ecomapp-dev-v2.s3.ap-south-1.amazonaws.com/Coin.png" loading="lazy">' +
//           popCoins +
//           '</div><img class="arrow" width="16" height="13" src="https://ecomapp-dev.s3.ap-south-1.amazonaws.com/media/arrow-right.png" loading="lazy">';
//         popcoinBtnSpan.innerHTML = popCoinBarHTML;
//       }
//     }
//   }
// }
// Bottom Bar 
const bottomStrip=(data)=>{
  const popClubStripe = document.querySelector("#popcoinBtnSpan");
    //Home page bottom strip
  if(data.success == true && data.coins>0){
    let bottomCoins=data.coins;
    let popHTMLStripe = 
              '<span class="rewards-title">' +
              rewardsName +
              "</span>" +
              rewardsCallOut +
              ` <div class="available_popcoins"><img width="30" height="30" src="${popIconAPI}" loading="lazy">` +
              data.coins +
              `</div>${popArrowSvg}`;
    popClubStripe.innerHTML = popHTMLStripe;
  }
  //Zero balance bottom strip
   if(data.success == true && data.coins==0){
    let bottomCoins=data.coins;
    let popHTMLStripe = 
              `<div class="available_popcoins"><img width="30" height="30" src="${popIconAPI}" loading="lazy">` +
              data.coins +
              `</div><span class="zeroPopcoinsCallout">Shop and Earn POPcoins</span> ${popArrowSvg}`;
    popClubStripe.innerHTML = popHTMLStripe;
  }
}
function addPopcoinsInMenu() {

  // let desktop_nav = document.querySelector(".list-menu");

  // let li_menu = document.createElement("li");
  // li_menu.setAttribute("class", "popcoinsMenu");

  // let menu = document.createElement("a");
  // menu.setAttribute(
  //   "class",
  //   "header__menu-item list-menu__item link link--text focus-inset"
  // );
  // menu.setAttribute("onclick", "openPopcoinsModal()");

  // let menuSpan = document.createElement("span");
  // menuSpan.setAttribute(
  //   "class",
  //   "text"
  // );
  // menuSpan.innerHTML = rewardNameLottieAnimationLink;
  // menu.appendChild(menuSpan);
  // li_menu.appendChild(menu);
  // desktop_nav.appendChild(li_menu);

  // mobile menu
  let mobile_nav = document.querySelector(".Drawer__Container .SidebarMenu__Nav--primary");
  let li_mob_menu = document.createElement("div");
  li_mob_menu.setAttribute("class", "Collapsible popcoinMobMenu");

  let mob_menu = document.createElement("a");
  mob_menu.setAttribute("onclick", "openPopcoinsModal()");
  mob_menu.setAttribute('class', 'Collapsible__Button Heading Link Link--primary u-h6');
  mob_menu.innerHTML = rewardNameLottieAnimationLink;

  li_mob_menu.appendChild(mob_menu);
  mobile_nav.appendChild(li_mob_menu);
}
function cartDrawer() {
  let cartDrawerParentElement = document.querySelectorAll(
    ".Drawer__Container .Cart__ItemList .CartItemWrapper"
  );
  let cartDrawerChildElement = ".Drawer__Container .Cart__ItemList .CartItemWrapper .CartItem__PriceList";
  let cartDrawerPopcoinsLabel = document.querySelector(
    "#buy-with-pop-coins-cart-drawer-label"
  );
  if (cartDrawerPopcoinsLabel) {
    cartDrawerPopcoinsLabel.addEventListener("click", function () {
      if (popCoinsLoginFlag.value == "false") {
        if (document.querySelector("#popcoinsIframe").src.toString().includes('-cart') == true) {
          // load_iframe(true);
          openPopcoinsModal();
        }
        else {
          load_iframe(true);
          openPopcoinsModal();
        }
      }
    });
  }

  fetch(window.Shopify.routes.root + "cart.js", {
    method: "GET",
  })
    .then((response) => response.json())
    .then((cartData) => {
      if (cartData["items"].length != 0) {
        let j = 0;
        cartDrawerParentElement.forEach((lineItem) => {
          let priceLenght = cartData["items"][j].price.toString().length - 2;
          let quantity = cartData["items"][j].quantity;
          let price =
            cartData["items"][j].price.toString().slice(0, priceLenght) +
            "." +
            cartData["items"][j].price.toString().slice(priceLenght);

          let priceValue = Math.floor(price);
          if (priceValue.toString().length > 2) {
            var modulePrice = priceValue % 100;
            var roundedPrice = priceValue - modulePrice;
          } else {
            var roundedPrice = 0;
          }
          let issueCoins = Math.round(
            (localStorage.getItem("popCoinsIssuance") / 100) *
            roundedPrice *
            quantity
          );
          // console.log("issueCoins",issueCoins);
          if (issueCoins >= 5) {
            let lineItemPopcoins =
              `<p id='product-issuance-msg' class='popCoinsEarnCallout'>Earn<span class='pop-img'> <img src='${popIconAPI}' loading='lazy'> </span> ` +
              issueCoins.toString() +
              "</p>";

            lineItem
              .querySelector(cartDrawerChildElement)
              .appendChild(create("div"));
            lineItem
              .querySelector(cartDrawerChildElement)
              .querySelector(".manual-class").innerHTML = lineItemPopcoins;
          }

          j++;
        });
      }
    })
    .catch((error) => {
      console.log("Cart js error - popcoins", error);
    });
}

//cart update
function updateCartData(currKey) {

  let updatenew = {
    'line': 1,
    'properties': { '__pop_id': currKey }
  }

  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updatenew)
  })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });

}

function cartPage() {
  let cartPageParentElement = document.querySelectorAll(
    ".Cart--expanded .Cart__ItemList .CartItem"
  );
  let cartPageChildElement = ".Cart--expanded .Cart__ItemList .CartItem .CartItem__PriceList";
  if (cartPagePopcoinsLabel) {
    cartPagePopcoinsLabel.addEventListener("click", function () {
      if (popCoinsLoginFlag.value == "false") {
        openPopcoinsModal();
      }
    });
  }
  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((cartData) => {
      if (cartData["items"].length > 0) {
        let c = 0;

        cartPageParentElement.forEach((lineItem) => {

          let priceLenght = cartData["items"][c].price.toString().length - 2;
          let quantity = cartData["items"][c].quantity;
          let price =
            cartData["items"][c].price.toString().slice(0, priceLenght) +
            "." +
            cartData["items"][c].price.toString().slice(priceLenght);
          let priceValue = Math.floor(price);
          console.log("priceValue.toString()", priceValue.toString())
          if (priceValue.toString().length > 2) {

            let modulePrice = priceValue % 100;
            roundedPrice = priceValue - modulePrice;
          }
          else {
            roundedPrice = 0;
          }

          let issueCoins = Math.round((localStorage.getItem("popCoinsIssuance") / 100) * roundedPrice * quantity);
          if (issueCoins > 0) {
            var newstring =
              `<p id='product-issuance-msg' class='popCoinsEarnCallout'>Earn<span class='pop-img'> <img src='${popIconAPI}' width='20' height='21' loading='lazy'> </span> ` +
              issueCoins +
              " <img class='info-popup-coin' src='https://d20pzmflnl47dv.cloudfront.net/media/icon-i.png' onclick=javascript:openPopcoinsModal('" +
              key +
              "') loading='lazy'></p>";
            var coinDiv = lineItem.querySelector(".CartItem__PriceList").querySelector(".manual-class");
            if (coinDiv != null) {
              // coinDiv.remove();
              lineItem.querySelectorAll(".manual-class").forEach((old_item) => {
                old_item.remove();
              });
            }
            lineItem.querySelector(".CartItem__PriceList").appendChild(create("div"));
            lineItem.querySelector(".CartItem__PriceList").querySelector(".manual-class").innerHTML = newstring;
            c++;
          }
        });
      }
    });
}

function variantSelector() {
  let regular_price = document.querySelector(".product__info-container .price__container .price-item");
  if (regular_price) {
    let temp_str = regular_price.innerHTML.replace("Rs. ", "").replace(",", "");
    let variantPrice = parseFloat(temp_str.trim());
    let popClubProductPrice = document.querySelector(
      ".product__info-container .pop-club-product"
    );

    if (popClubProductPrice)
      popClubProductPrice.setAttribute("price", variantPrice);
  }
}

function cartPageSubTotalChanges(data) {
  let cartPagePopcoinsLabel = document.querySelector(
    "#buy-with-pop-coins-cart-page-label"
  );
  let cartPagePopcoinsCheckbox = document.querySelector(
    "#buy-with-pop-coins-cart-page-checkbox"
  );

  function prices_val() {
    const afterPopDiscountPrice = document.querySelector(
      ".Cart__Recap .Cart__Total span"
    );

    let price_value = "Rs. " + " " + afterPopDiscountPrice.textContent.split(" ")[1];
    afterPopDiscountPrice.innerHTML = price_value;
  }

  fetch(window.Shopify.routes.root + "cart.js", {
    method: "GET",
  })
    .then((response) => response.json())
    .then((cartData) => {
      let priceLength = cartData["items_subtotal_price"].toString().length - 2;
      let price =
        cartData["items_subtotal_price"].toString().slice(0, priceLength) +
        "." +
        cartData["items_subtotal_price"].toString().slice(priceLength);
      let dataRedeem = localStorage.getItem("popCoinsRedeem");
      let dataCoins = data.coins;
      let redeemCoins = Math.round((dataRedeem / 100) * price);
      let redeemPrice = Math.round(price - redeemCoins);

      if (redeemCoins > dataCoins && popCoinsLoginFlag.value == "true") {
        redeemCoins = dataCoins;
      }
      if (cartPagePopcoinsCheckbox && cartPagePopcoinsLabel) {
        if (popCoinsLoginFlag.value == "true") {
          if (dataCoins > 0) {

            cartPagePopcoinsCheckbox.style.display = "inline-block";
          }
          else {
            cartPagePopcoinsCheckbox.style.display = "none";
          }

          if (cartPagePopcoinsCheckbox.checked) {
            console.log("pop_cart_page_checkbox checked");
            if (redeemCoins == 0) {
              popHTML = "You have 0 POPcoins. Shop now & earn coins." + lottieAnimation;
              cartPagePopcoinsCheckbox.checked = false;
              cartPagePopcoinsCheckbox.style.display = "none";
              prices_val();
            } else {
              // addExternalDiscount(cartData);
              
              popHTML = " Rs. " + redeemCoins + " | Saved using POPcoins" + lottieAnimation;
              prices_val();
            }
            const paragraph = document.querySelector(".Cart__Recap .Cart__Total span");

            let paragraph3 = paragraph.textContent;
            let paragraph1 = paragraph3.split(" ");
            let subTotal = paragraph1[1].replace(",", "");
            let main_value = price - redeemCoins;
            let main_value1 = parseFloat(main_value).toFixed(2);

            paragraph.innerText = paragraph1[0] + " " + main_value1;
            subTotal = price;

          } else {
            console.log("page checkbox is false");
            const paragraph = document.querySelector(".Cart__Recap .Cart__Total span");

            var paragraph3 = paragraph.textContent;
            let paragraph1 = paragraph3.split(" ");

            paragraph.innerText = paragraph1[0] + " " + price;


            if (redeemCoins == 0) {
              popHTML = "You have 0 POPcoins. Shop now & earn coins." + lottieAnimation;
              cartPagePopcoinsCheckbox.checked = false;
              prices_val();
            } else {
              removeExternalDiscount();
              popHTML =
                " Save Rs. " + redeemCoins + " using POPcoins" + lottieAnimation;
              prices_val();
            }
          }
        } else {
          console.log("flag is false");
          cartPagePopcoinsCheckbox.checked = false;
          cartPagePopcoinsCheckbox.style.display = "none";
          popHTML =
            "<span class='popCoinsClickBtn'>Click</span><span class='popCoinsClickCallout'> & get upto 30% off using POPcoins</span>" + lottieAnimation;
        }
        cartPagePopcoinsLabel.innerHTML = popHTML;
      }
    });
}

function cartDrawerSubTotalChanges() {
  let cartDrawerPopcoinsLabel = document.querySelector(
    "#buy-with-pop-coins-cart-drawer-label"
  );
  let cartDrawerPopcoinsCheckbox = document.querySelector(
    "#buy-with-pop-coins-cart-drawer-checkbox"
  );
  const afterPopDiscountPrice = document.querySelector(
    ".Drawer__Footer #checkout3 .pop-sub-price"
  );

  console.log("cart drawer subtotal function called");

  if (afterPopDiscountPrice) {
    function cartDrawer_prices_val() {
      console.log(afterPopDiscountPrice);
      let price_value = " Rs. " + " " + afterPopDiscountPrice.textContent.split(" ")[1];
      afterPopDiscountPrice.innerHTML = "Rs. " + price_value;

      const checkoutBtnPrice = document.querySelector(".Drawer__Footer #checkout3 .pop-sub-price");
      let btn_price_value = "Rs. " + " " + checkoutBtnPrice.textContent.split(" ")[1];
      checkoutBtnPrice.innerHTML = price_value;
    }

    fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
    })
      .then((response) => response.json())
      .then((cartData) => {
        let priceLength = cartData["items_subtotal_price"].toString().length - 2;
        let price =
          cartData["items_subtotal_price"].toString().slice(0, priceLength) +
          "." +
          cartData["items_subtotal_price"].toString().slice(priceLength);
        let dataRedeem = localStorage.getItem("popCoinsRedeem");
        let dataCoins = popCoins;
        let redeemCoins = Math.round((dataRedeem / 100) * price);
        let redeemPrice = Math.round(price - redeemCoins);

        if (redeemCoins > dataCoins && popCoinsLoginFlag.value == "true") {
          redeemCoins = dataCoins;
        }
        if (cartDrawerPopcoinsCheckbox && cartDrawerPopcoinsLabel) {
          if (popCoinsLoginFlag.value == "true") {
            if (dataCoins > 0) {

              cartDrawerPopcoinsCheckbox.style.display = "inline-block";
            }
            else {
              cartDrawerPopcoinsCheckbox.style.display = "none";

            }
            if (cartDrawerPopcoinsCheckbox.checked) {
              console.log("pop_cart_drawer_checkbox checked");
              if (redeemCoins == 0) {
                popHTML = "You have 0 POPcoins. Shop now & earn coins." + lottieAnimation;
                cartDrawerPopcoinsCheckbox.checked = false;
                cartDrawerPopcoinsCheckbox.style.display = "none";
                cartDrawer_prices_val();
              } else {
                cartDrawer_prices_val();
                // addExternalDiscount(cartData);
                const checkoutBtn=document.querySelector("#checkout3");
                if(checkoutBtn) checkoutBtn.setAttribute("disabled","true");
                 if(checkoutBtn) checkoutBtn.classList.add("disable-btn");
                cartDiscoutAPI();
                popHTML =
                  "Rs. " +
                  redeemCoins +
                  " | Saved using POPcoins" + lottieAnimation;
              }

              const paragraph = document.querySelector(".Drawer__Footer #checkout3 .pop-sub-price");
              if (paragraph) {
                let paragraph3 = paragraph.textContent;
                let paragraph1 = paragraph3.split(" ");
                let subTotal = paragraph1[1].replace(",", "");
                let main_value = price - redeemCoins;
                let main_value1 = parseFloat(main_value).toFixed(2);

                paragraph.innerText = "Rs. " + paragraph1[0] + " " + main_value1;
                subTotal = price;
                console.log("subtotal", subTotal);
              }

              // const checkoutBtnPrice = document.querySelector("#CartDrawer-Checkout .total-text");

              //  let a = checkoutBtnPrice.textContent;
              //  let b = a.split(" ");
              //  let c = b[1].replace(",", "");

              //  checkoutBtnPrice.innerText = b[0] + " " + main_value1;
              //  c = price;


            } else {
              console.log("drawer checkbox is false");
              removeExternalDiscount();
              const paragraph = document.querySelector(".Drawer__Footer #checkout3 .pop-sub-price");
              if (paragraph) {

                var paragraph3 = paragraph.textContent;
                let paragraph1 = paragraph3.split(" ");

                paragraph.innerText = paragraph1[0] + " " + price;
                //           const checkoutBtnPrice = document.querySelector("#CartDrawer-Checkout .total-text");

                // var a = checkoutBtnPrice.textContent;
                // let b = a.split(" ");

                // checkoutBtnPrice.innerText = b[0] + " " + price;
              }
              if (redeemCoins == 0) {
                popHTML = "You have 0 POPcoins. Shop now & earn coins." + lottieAnimation;
                cartDrawerPopcoinsCheckbox.checked = false;
                cartDrawer_prices_val();
              } else {
                popHTML = " Save Rs. " + redeemCoins + " using POPcoins" + lottieAnimation;
                cartDrawer_prices_val();
              }
            }
          } else {
            console.log("drawer flag is false");

            cartDrawerPopcoinsCheckbox.checked = false;
            cartDrawerPopcoinsCheckbox.style.display = "none";
            popHTML =
              "<span class='popCoinsClickBtn'>Click</span><span class='popCoinsClickCallout'> & get upto 30% off using POPcoins</span>" + lottieAnimation;
          }
          cartDrawerPopcoinsLabel.innerHTML = popHTML;
        }
      });
  }
}

function popcoinsOnPDP(data) {
  let popcoinsPdpDiv = document.querySelector(".pop-club-product");

  let pdpPopcoinsLabel = document.querySelector(
    "#buy-with-pop-coins-pdp-label"
  );
  let pdpPopcoinsCheckbox = document.querySelector(
    "#buy-with-pop-coins-pdp-checkbox"
  );
  let price = popcoinsPdpDiv.getAttribute("price");
  let pdpQty1 = 0;
  pdpQty1 = document.querySelector(
    ".productView-product .quantity__container .quantity__input"
  );

  let totalProductPrice1 = price * parseInt(pdpQty1.value);

  let redeemCoins = Math.round(
    (localStorage.getItem("popCoinsRedeem") / 100) * totalProductPrice1
  );

  if (popCoinsLoginFlag.value == "true") {
    pdpPopcoinsCheckbox.style.display = "block";

    document.getElementById("pop-club-redeem-price").value = redeemCoins;
    if (redeemCoins > popCoins && data.success == true) {
      redeemCoins = popCoins;
      document.getElementById("pop-club-redeem-price").value = redeemCoins;
    }
    console.log("flag is true");
    if (pdpPopcoinsCheckbox.checked) {
      console.log("pdp checkbox checked");
      if (redeemCoins == 0) {
        popHTML = "You have 0 POPcoins. Shop now & earn coins." + lottieAnimation;
        pdpPopcoinsCheckbox.checked = false;
        pdpPopcoinsCheckbox.style.display = "none";
      } else {
        popHTML = " Rs. " + redeemCoins + " | Saved using POPcoins" + lottieAnimation;
        fetch(window.Shopify.routes.root + "cart.js", {
          method: "GET",
        })
          .then((response) => response.json())
          .then((cartData) => {
            // addExternalDiscount(cartData);
          });
      }
    } else {
      console.log("pdp checkbox is false");
      removeExternalDiscount();
      if (redeemCoins == 0) {
        popHTML = "You have 0 POPcoins. Shop now & earn coins." + lottieAnimation;
        pdpPopcoinsCheckbox.checked = false;
        pdpPopcoinsCheckbox.style.display = "none";
      } else {
        popHTML =

          " Save Rs. " + redeemCoins + " using POPcoins" + lottieAnimation;
      }
    }
    pdpPopcoinsLabel.innerHTML = popHTML;
  }
}


function addExternalDiscount(data) {
  let externalCheckoutBtn = document.querySelector(externalCheckout);
  let popcoinsLoader = document.querySelector(".popCoinsLoader");
  // popcoinsLoader.style.display = "block";
  externalCheckoutBtn.disabled = true;
  // customAddClass("body", "popcoinsModalActive");


  let priceLenght = data["items_subtotal_price"].toString().length - 2;
  let price =
    data["items_subtotal_price"].toString().slice(0, priceLenght) +
    "." +
    data["items_subtotal_price"].toString().slice(priceLenght);
  let variants = "";
  for (let i = 0; i < data["items"].length; i++) {
    variants +=
      data["items"][i]["variant_id"] +
      "-" +
      data["items"][i]["quantity"] +
      ",";
  }

  let checkoutParameters =
    "?cart=" +
    price +
    "&shop=" +
    Shopify.shop +
    "&key=" +
    key +
    "&variants=" +
    variants;

  fetch(getCartDiscountURL + checkoutParameters)
    .then((response) => response.json())
    .then((data) => {
      if (data.success == true) {
        // window.location = data.url;
        var now = new Date();
        var time = now.getTime();
        time += 3600 * 1000;
        now.setTime(time);

        document.cookie =
          "discount_code=" +
          data.code +
          "; expires=" +
          now.toUTCString() +
          "; path=/";
        console.log("external discount added");
        setTimeout(function () {
          console.log("Loader removed");
          externalCheckoutBtn.disabled = false;
          // popcoinsLoader.style.display = "none";
          // customRemoveClass("body", "popcoinsModalActive");
        }, 1000);
      }
    });

}

function removeExternalDiscount() {
  let externalCheckoutBtn = document.querySelectorAll(externalCheckout);
  console.log("removed external discount");
  externalCheckoutBtn.disabled = true;
  document.cookie =
    "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
  const checkoutBtn=document.querySelector("#checkout3");
          if(checkoutBtn) checkoutBtn.removeAttribute("disabled");
          if(checkoutBtn) checkoutBtn.classList.remove("disable-btn");
  fetch(removeDiscountCode + parameters, {
    Method: "POST",
  })
    .then((response) => {
      //handle respons
      externalCheckoutBtn.disabled = false;

    })
    .catch((error) => {
      console.log("Error removing discount - popcoins");
    });
}
if (window.location.href.indexOf('/cart') != -1) {
  $(document).on('click', '#buy-with-pop-coins-cart-page-label', function () {
    if (popCoinsLoginFlag.value == "false") {
      openPopcoinsModal();
    }
  })
}
$(document).ready(function () {
  $(window).scroll(function () {
    let stickyAdd = $('.uplinkly-sticky-cart-button');
    if (stickyAdd.css('bottom') === '0px') {
      stickyAdd.css({
        'bottom': '45px',
      });
    }
  })
})
$(document).ready(function () {
  $(window).load(function () {

    var flickityHeight = $('.flickity-viewport').outerHeight();
    var mainheight = flickityHeight + 50;
    $('.flickity-viewport').css({
      'height': mainheight
    });
  });
});
